import { FaFacebookF, FaPhoneAlt } from "react-icons/fa";
import { SiZalo } from "react-icons/si";
import integrationBackgroundMain from "../../../../../../assets/images/integration-page1.png";
import integrationBackgroundBottom from "../../../../../../assets/images/integration-page2.png";
import { useState } from "react";
import IntegrationCard from "./IntegrationCard";
import { motion, AnimatePresence } from "framer-motion";
import { INTEGRATION_ID } from "../../../../constant";

const cards = [
    {
        icon: (
            <svg width="50" height="50" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.91975 46.798C4.91485 46.798 2.95613 46.2864 1.18097 45.2896C0.267625 44.8193 -0.0861298 43.6425 0.459502 42.7572C2.27238 39.8603 2.92702 36.3192 2.09699 32.989C1.23666 29.5365 -0.00816122 26.6288 0.000749476 22.974C0.0316399 10.1513 10.7044 -0.243895 23.514 0.00486169C35.8865 0.254064 46.0831 10.6546 46.0833 23.0304C46.0834 39.1933 29.1445 50.5411 14.1904 44.2996C12.1292 45.9175 9.53846 46.798 6.91975 46.798ZM4.48357 42.8518C7.30054 43.7267 10.4687 43.0278 12.641 40.9277C13.1762 40.4101 13.9769 40.2799 14.6484 40.6011C27.4512 46.7223 42.519 37.1278 42.5189 23.0304C42.5189 12.5107 33.961 3.78017 23.4423 3.5684C12.6021 3.35305 3.59116 12.1325 3.56503 22.9826C3.55656 26.454 4.91099 29.2284 5.65117 32.5169C6.431 35.9824 6.02022 39.647 4.48357 42.8518Z" fill="#5AE65E"/>
            <path d="M53.0801 60.0004C50.4615 60.0004 47.8706 59.1197 45.8097 57.5021C37.8569 60.8212 28.397 59.3096 21.8763 53.6784C21.1314 53.035 21.0491 51.9097 21.6923 51.1647C22.3357 50.4199 23.461 50.3373 24.2059 50.9808C29.9892 55.9753 38.459 57.0987 45.3516 53.8036C46.023 53.4822 46.8235 53.6126 47.359 54.1301C49.5311 56.2301 52.6995 56.9294 55.5164 56.0541C53.7037 52.2732 53.4526 47.9415 54.8573 43.9314C54.87 43.8953 54.8838 43.8598 54.8986 43.8245C55.9245 41.406 56.4415 38.8355 56.4351 36.1849C56.4238 31.5115 54.8692 27.1885 51.9391 23.6829C51.3079 22.9276 51.4085 21.8038 52.1636 21.1726C52.9187 20.5413 54.0427 20.642 54.6739 21.3972C58.095 25.4903 59.9863 30.7388 59.9994 36.1763C60.007 39.2907 59.4027 42.3132 58.2034 45.1611C56.9438 48.8075 57.5231 52.7117 59.5403 55.9592C60.0864 56.8446 59.7324 58.0216 58.8187 58.4922C57.0439 59.4886 55.0847 60.0002 53.0801 60.0004Z" fill="#5AE65E"/>
            <path d="M23.0419 25.9377C24.5993 25.9377 25.8618 24.6758 25.8618 23.1192C25.8618 21.5626 24.5993 20.3008 23.0419 20.3008C21.4845 20.3008 20.222 21.5626 20.222 23.1192C20.222 24.6758 21.4845 25.9377 23.0419 25.9377Z" fill="#5AE65E"/>
            <path d="M12.6526 25.9377C14.21 25.9377 15.4725 24.6758 15.4725 23.1192C15.4725 21.5626 14.21 20.3008 12.6526 20.3008C11.0952 20.3008 9.83267 21.5626 9.83267 23.1192C9.83267 24.6758 11.0952 25.9377 12.6526 25.9377Z" fill="#5AE65E"/>
            <path d="M33.4313 25.9377C34.9887 25.9377 36.2512 24.6758 36.2512 23.1192C36.2512 21.5626 34.9887 20.3008 33.4313 20.3008C31.8739 20.3008 30.6114 21.5626 30.6114 23.1192C30.6114 24.6758 31.8739 25.9377 33.4313 25.9377Z" fill="#5AE65E"/>
            </svg>

        ),
        title: 'Communication Channels',
        desc: 'Chat Me can be embedded into websites, integrated with messaging apps, and incorporated into mobile apps to enhance customer support and personalize user experiences.'
    },
    {
        icon: (
            <svg width="50" height="50" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M52.9888 44.6232C52.7146 46.5432 52.2174 48.3774 51.2917 50.0574C48.1031 55.9203 43.1831 59.0403 36.4974 59.246C33.686 59.3317 30.8574 59.2803 28.046 59.2632C25.6288 59.246 23.7603 57.4117 23.7774 55.0632C23.7774 52.7146 25.646 50.8974 28.0803 50.8974C29.246 50.8974 30.3946 50.8974 31.5603 50.8974C34.4574 50.8974 35.966 52.1832 36.3945 55.0289C42.6517 55.3032 48.1374 49.9374 48.6517 44.6232C47.126 44.006 46.8346 43.5774 46.8346 41.9146C46.8346 38.0232 46.8346 34.1489 46.8346 30.2574C46.8346 28.646 47.6403 27.8403 49.2517 27.8403C49.8174 27.8403 50.3831 27.8403 51.0003 27.8403C51.3774 19.766 48.6517 13.1146 41.9317 8.55459C34.6117 3.54888 26.7945 3.30888 19.2003 7.88602C11.8288 12.326 8.76026 19.2517 9.12026 27.8232C9.82312 27.8232 10.4746 27.8232 11.1088 27.8232C12.4117 27.8403 13.286 28.7146 13.3031 30.0003C13.3203 34.1317 13.3203 38.246 13.3031 42.3774C13.3031 43.6803 12.4288 44.5717 11.126 44.5717C9.41169 44.5717 7.66312 44.6574 5.96598 44.4346C3.15455 44.0746 0.994549 41.7774 0.771692 38.9146C0.634549 37.0117 0.63455 35.0574 0.823121 33.1546C1.04598 30.926 2.38312 29.366 4.38883 28.406C4.80026 28.2174 4.92026 28.0117 4.90312 27.5832C4.78312 24.0689 5.07455 20.5889 6.36026 17.2803C9.82312 8.31459 16.2517 2.65745 25.7317 0.977448C39.1546 -1.42255 51.7203 7.16602 54.6517 20.4346C55.166 22.7489 55.2688 25.0974 55.2003 27.4632C55.1831 27.9432 55.3031 28.2174 55.7831 28.4574C58.1145 29.5889 59.3317 31.4917 59.3831 34.0803C59.4174 35.7774 59.5031 37.5089 59.2803 39.1717C58.8688 42.2917 56.4517 44.3832 53.2974 44.5546C53.246 44.606 53.1603 44.606 52.9888 44.6232ZM9.08598 32.0232C8.29741 32.0232 7.57741 31.9889 6.85741 32.0232C5.79455 32.0746 4.93741 32.966 4.92026 34.046C4.88598 35.486 4.88598 36.926 4.92026 38.366C4.93741 39.3774 5.67455 40.2517 6.66884 40.3546C7.45741 40.4403 8.26312 40.3717 9.08598 40.3717C9.08598 37.5946 9.08598 34.8517 9.08598 32.0232ZM51.0517 40.406C51.8745 40.406 52.6288 40.4574 53.3831 40.3889C54.3946 40.3032 55.2003 39.4289 55.2174 38.4174C55.2517 36.9603 55.2517 35.486 55.2174 34.0289C55.2003 33.1203 54.5831 32.2803 53.6917 32.1432C52.8346 32.0232 51.9431 32.1089 51.0517 32.1089C51.0517 34.8517 51.0517 37.5774 51.0517 40.406Z" fill="#5AE65E"/>
            <path d="M18.3603 25.7319C19.7831 27.1547 21.1546 28.5261 22.526 29.8976C22.766 30.1376 23.006 30.3604 23.2117 30.6004C23.9831 31.4576 23.966 32.6919 23.1774 33.4976C22.3717 34.3204 21.086 34.3547 20.2289 33.5319C19.1146 32.4519 18.0346 31.3376 16.9374 30.2576C15.9603 29.2804 14.9831 28.3204 14.0231 27.3433C13.046 26.349 13.046 25.1661 14.0403 24.1719C16.0631 22.149 18.086 20.1261 20.1089 18.1033C21.0346 17.1776 22.286 17.1433 23.1431 17.9833C24.0174 18.8404 24.0003 20.1261 23.0574 21.069C21.5317 22.5776 19.9717 24.1204 18.3603 25.7319Z" fill="#5AE65E"/>
            <path d="M41.8117 25.7318C40.166 24.1033 38.5717 22.5433 37.0289 20.949C35.846 19.7318 36.3431 17.829 37.9374 17.4175C38.6917 17.2118 39.3774 17.4004 39.926 17.949C42.0346 20.0404 44.1431 22.1318 46.2174 24.2575C47.0746 25.1147 47.0746 26.3318 46.2174 27.189C44.126 29.2975 42.0346 31.4061 39.926 33.4804C39.0689 34.3204 37.8003 34.3033 36.9774 33.4975C36.1374 32.6747 36.1203 31.389 36.9946 30.5147C38.5717 28.9375 40.166 27.3775 41.8117 25.7318Z" fill="#5AE65E"/>
            <path d="M34.2689 19.5945C34.2346 19.7316 34.1832 20.023 34.0974 20.3145C32.7603 24.3602 31.406 28.4059 30.0517 32.4687C29.6746 33.583 28.9032 34.1659 27.8917 34.1145C26.966 34.0802 26.1774 33.463 25.9717 32.5202C25.886 32.143 25.9032 31.6802 26.0232 31.303C27.3946 27.1373 28.766 22.9887 30.1717 18.8402C30.5317 17.7773 31.4746 17.1945 32.486 17.3487C33.4974 17.5373 34.2517 18.4116 34.2689 19.5945Z" fill="#5AE65E"/>
            </svg>
        ),
        title: 'Customer Service Applications',
        desc: 'Chat Me streamlines customer service by managing common queries and integrating with CRM systems for personalized interactions and 24/7 support.'
    },
    {
        icon: (
            <svg width="50" height="50" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.15229 3.75586C6.06361 3.75586 3.52209 6.29738 3.52209 9.38605V22.5427C3.52209 25.6314 6.06361 28.1692 9.15229 28.1692H22.309C25.3976 28.1692 27.9355 25.6314 27.9355 22.5427V9.38605C27.9355 6.29738 25.3976 3.75586 22.309 3.75586H9.15229ZM37.3216 3.75586C34.2329 3.75586 31.6914 6.29738 31.6914 9.38605V22.5427C31.6914 25.6314 34.2329 28.1692 37.3216 28.1692H50.4782C53.5669 28.1692 56.1048 25.6314 56.1048 22.5427V9.38605C56.1048 6.29738 53.5669 3.75586 50.4782 3.75586H37.3216ZM9.15229 7.51543H22.309C23.3818 7.51543 24.1796 8.31318 24.1796 9.38605V22.5427C24.1796 23.6156 23.3818 24.4133 22.309 24.4133H9.15229C8.07941 24.4133 7.278 23.6156 7.278 22.5427V9.38605C7.278 8.31318 8.07941 7.51543 9.15229 7.51543ZM37.3216 7.51543H50.4782C51.5511 7.51543 52.3489 8.31318 52.3489 9.38605V22.5427C52.3489 23.6156 51.5511 24.4133 50.4782 24.4133H37.3216C36.2487 24.4133 35.4473 23.6156 35.4473 22.5427V9.38605C35.4473 8.31318 36.2487 7.51543 37.3216 7.51543ZM9.15229 31.9251C6.06361 31.9251 3.52209 34.4667 3.52209 37.5553V50.712C3.52209 53.8007 6.06361 56.3385 9.15229 56.3385H22.309C25.3976 56.3385 27.9355 53.8007 27.9355 50.712V37.5553C27.9355 34.4667 25.3976 31.9251 22.309 31.9251H9.15229ZM37.3216 31.9251C34.2329 31.9251 31.6914 34.4667 31.6914 37.5553V50.712C31.6914 53.8007 34.2329 56.3385 37.3216 56.3385H50.4782C53.5669 56.3385 56.1048 53.8007 56.1048 50.712V37.5553C56.1048 34.4667 53.5669 31.9251 50.4782 31.9251H37.3216ZM9.15229 35.6847H22.309C23.3818 35.6847 24.1796 36.4825 24.1796 37.5553V50.712C24.1796 51.7849 23.3818 52.5826 22.309 52.5826H9.15229C8.07942 52.5826 7.278 51.7849 7.278 50.712V37.5553C7.278 36.4825 8.07942 35.6847 9.15229 35.6847ZM37.3216 35.6847H50.4782C51.5511 35.6847 52.3489 36.4825 52.3489 37.5553V50.712C52.3489 51.7849 51.5511 52.5826 50.4782 52.5826H37.3216C36.2487 52.5826 35.4473 51.7849 35.4473 50.712V37.5553C35.4473 36.4825 36.2487 35.6847 37.3216 35.6847Z" fill="#5AE65E"/></svg>

        ),
        title: 'Other Applications',
        desc: 'It can be deployed across social media, e-commerce platforms, and internal tools to manage interactions, support marketing and sales, and automate organizational tasks.'
    }
];

const IntegrationPage = () => {
    const [mobileIndex, setMobileIndex] = useState(0);
    const [touchStartX, setTouchStartX] = useState(null);
    const [touchEndX, setTouchEndX] = useState(null);
    const [direction, setDirection] = useState(0); // -1 for left, 1 for right

    const handleDotClick = (idx) => {
        if (idx !== mobileIndex) {
            setDirection(idx > mobileIndex ? 1 : -1);
            setMobileIndex(idx);
        }
    };

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEndX(e.touches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (touchStartX !== null && touchEndX !== null) {
            const diff = touchStartX - touchEndX;
            if (diff > 50) {
                // Swipe left, next
                setDirection(1);
                setMobileIndex(i => (i === cards.length - 1 ? 0 : i + 1));
            } else if (diff < -50) {
                // Swipe right, prev
                setDirection(-1);
                setMobileIndex(i => (i === 0 ? cards.length - 1 : i - 1));
            }
        }
        setTouchStartX(null);
        setTouchEndX(null);
    };

    const slideVariants = {
        enter: (direction) => ({
            x: direction > 0 ? 1000 : -1000,
            opacity: 0
        }),
        center: {
            zIndex: 1,
            x: 0,
            opacity: 1
        },
        exit: (direction) => ({
            zIndex: 0,
            x: direction < 0 ? 1000 : -1000,
            opacity: 0
        })
    };

    const dotVariants = {
        active: {
            scale: 1.25,
            backgroundColor: "#5AE65E",
            transition: { duration: 0.15 }
        },
        inactive: {
            scale: 1,
            backgroundColor: "#FFFFFF",
            transition: { duration: 0.15 }
        }
    };

    return (
        <div id={INTEGRATION_ID} className="relative flex flex-col items-center overflow-hidden bg-black min-h-[850px] md:h-[1000px]" style={{backgroundColor: '#031602'}}>
            {/* Main background image: covers all */}
            <div
                className="absolute inset-0 z-0 w-full h-full top-[3rem] sm:top-[0rem] md:top-[0.5rem] lg:top-[1.5rem]"
                style={{
                    width: '100%',
                    height: '400px',
                    zIndex: 20,
                    backgroundImage: `url(${integrationBackgroundMain})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            />
            {/* Bottom background image overlay: only at bottom */}
            <div
                className="absolute z-10 w-full pointer-events-none left-0 right-0 top-[0.3rem] md:top-0"
                style={{
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${integrationBackgroundBottom})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center bottom',
                    backgroundRepeat: 'no-repeat',
                }}
            />
            <div className="w-full max-w-[1000px] relative z-20 flex flex-col items-center px-4 mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-center text-white mt-12 mb-2">
                    Effortless Integration: Chatme<br />
                    Connects with All Your Platforms
                </h2>
                <div className="w-full max-w-5xl mt-12 mb-10">
                    {/* Mobile: thủ công, chỉ 1 card, có nút prev/next */}
                    <div className="block md:hidden">
                        <div className="relative flex flex-col items-center">
                            <div
                                onTouchStart={handleTouchStart}
                                onTouchMove={handleTouchMove}
                                onTouchEnd={handleTouchEnd}
                                className="w-full"
                            >
                                <AnimatePresence initial={false} custom={direction} mode="wait">
                                    <motion.div
                                        key={mobileIndex}
                                        custom={direction}
                                        variants={slideVariants}
                                        initial="enter"
                                        animate="center"
                                        exit="exit"
                                        transition={{
                                            x: { type: "spring", stiffness: 3000, damping: 100, mass: 0.5 },
                                            opacity: { duration: 0.15 }
                                        }}
                                    >
                                        <IntegrationCard
                                            icon={cards[mobileIndex].icon}
                                            title={cards[mobileIndex].title}
                                            desc={cards[mobileIndex].desc}
                                        />
                                    </motion.div>
                                </AnimatePresence>
                            </div>
                            <div className="flex justify-center gap-2 mt-4">
                                {cards.map((_, idx) => (
                                    <motion.button
                                        key={idx}
                                        onClick={() => handleDotClick(idx)}
                                        variants={dotVariants}
                                        animate={idx === mobileIndex ? "active" : "inactive"}
                                        className="inline-block w-2 h-2 p-1 rounded-full border-1"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                    {/* Desktop: 3 cards */}
                    <div className="hidden md:flex flex-row gap-6 w-full justify-center">
                        {cards.map((card, idx) => (
                            <IntegrationCard
                                key={idx}
                                icon={card.icon}
                                title={card.title}
                                desc={card.desc}
                            />
                        ))}
                    </div>
                </div>
                {/* Social Icons and CTA */}
                <div className="flex flex-col items-center mt-6 mb-12">
                    <div className="flex gap-6 mb-4">
                        <a 
                            href="tel:0865526282" 
                            className="bg-green-500 rounded-full p-3 text-white text-2xl shadow-lg hover:bg-green-600 transition-colors relative group"
                            title="0865526282"
                        >
                            <FaPhoneAlt />
                            <span className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-black text-white text-sm py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                                0865526282
                            </span>
                        </a>
                        <a href="https://www.facebook.com/share/161nNzwFYQ/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="bg-blue-600 rounded-full p-3 text-white text-2xl shadow-lg hover:bg-blue-700 transition-colors"><FaFacebookF /></a>
                        <a href="https://zalo.me/0865526282" target="_blank" rel="noopener noreferrer" className="bg-blue-400 rounded-full p-3 text-white text-2xl shadow-lg hover:bg-blue-500 transition-colors"><SiZalo /></a>
                    </div>
                    <div className="text-2xl md:text-3xl font-semibold text-white text-center">
                        Ready to elevate your <span className="font-semibold bg-gradient-to-b from-white to-[#5AE65E] bg-clip-text text-transparent">customer service?</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IntegrationPage;
